declare const angular: ng.IAngularStatic;
declare const $0: HTMLElement;
type $scope = ng.IScope & {
    vm: object;
}

let vwoDebuggerText: string = '';

/**
 * Allows to access the scope of an element in devtools
 * @example
 * Select an element in devtools and then run $0.$scope
 */
Object.defineProperty(HTMLElement.prototype, '$scope', {
    get: function() {
        return angular.element(this).scope();
    }
});

Object.defineProperty(window, '$scope', {
    get: function() {
        return angular.element($0).scope();
    }
});

Object.defineProperty(HTMLElement.prototype, 'vm', {
    get: function() {
        return (angular.element(this).scope() as $scope).vm;
    }
});

Object.defineProperty(window, 'vm', {
    get: function() {
        return (angular.element($0).scope() as $scope).vm;
    }
});

const vwoDebugger = {
    watchProperty(object: Record<string, unknown>, key: string) {
        let value = object[key];

        delete object[key];
        Object.defineProperty(object, key, {
            get() {
                return value;
            },
            set(newValue) {
                // eslint-disable-next-line no-debugger
                debugger;
                value = newValue;
            },
            enumerable: true,
            configurable: true
        })
    },


    watchArray(array: any) {
        array.push = function(...item: any[]) {
            // eslint-disable-next-line no-debugger
            debugger
            Array.prototype.push.call(array, ...item)
        }

        array.pop = function() {
            // eslint-disable-next-line no-debugger
            debugger
            Array.prototype.pop.call(array)
        }

        array.splice = function(...item: any[]) {
            // eslint-disable-next-line no-debugger
            debugger
            Array.prototype.splice.call(array, ...item as Parameters<typeof Array.prototype.splice>)
        }
    },

    getAngularService(name: string, element: HTMLElement = document.body) {
        return angular.element(element || document.body).injector().get(name);
    },

    impersonate(account: string) {
        window.location.href = location.origin + '/access?accountId=' + account;
    },

    get $rootScope() {
        return this.getAngularService('$rootScope');
    },

    get $state() {
        return this.getAngularService('$state');
    },

    import(_module: string) {
        // eslint-disable-next-line no-console
        console.warn('import is not supported in build');
    }
};

if (import.meta.env.DEV) {
    vwoDebugger.import =   async function(module: string) {
        import('angular'); // this line has been added to get current working directory using following hack.
        vwoDebuggerText = vwoDebuggerText || await (await fetch('modules/_devScripts/vwoDebugger.ts')).text();
        // this is the pattern that vite creates for dynamic imports.
        const path = vwoDebuggerText.match('/@fs.*deps/')?.[0];

        if (module.includes('/')) {
            // if the module is a local module, import it from the modules folder.
            return await import(/* @vite-ignore */`/modules/${module}.ts`);
        } else {
            // if the module is a node_modules module, import it from the vite/deps folder.
            return await import(/* @vite-ignore */path + module + '.js');
        }
    }
}

Object.defineProperty(window, 'vwoDebugger', {
    value: vwoDebugger,
    configurable: false,
    writable: false
});
